<template>
  <div>
    <div class="table-responsive">
      <table class="table" style="border: unset !important">
        <tr>
          <td width="50%" align="center" style="vertical-align: top; border: 0 !important">
            <p style="text-align: center !important">ĐẠI DIỆN BÊN A</p>
            <img
              v-if="
                dataAppendix && dataAppendix.typeCustomer && dataAppendix.typeCustomer === 'COMPANY'
              "
              src="@/assets/img/signature.png"
              class="sign-block"
            />
            <img
              v-else-if="
                dataAppendix?.dateSignAppendixDTO ||
                dataAppendix?.dateCreatedAppendixDTO ||
                dataContract?.effectiveFromDTO
                  ? (dataAppendix?.dateSignAppendixDTO ||
                      dataAppendix?.dateCreatedAppendixDTO ||
                      dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                  : new Date() < new Date('2026-01-07')
              "
              src="@/assets/img/chuky2.jpg"
              class="sign-block"
            />
            <img
              v-else
              src="@/assets/img/chu_ky_moc.png"
              style="width: 241px !important; height: auto !important"
              class="sign-block"
            />
            <br />
          </td>
          <td width="50%" align="center" style="vertical-align: top; border: 0 !important">
            <p style="text-align: center !important">ĐẠI DIỆN BÊN B</p>
            <img v-if="sign" :src="sign" class="sign-block" alt="" />
            <img v-else-if="dataSign" :src="dataSign" class="sign-block" alt="" />
            <img
              v-else-if="
                dataAppendix && dataAppendix.typeCustomer && dataAppendix.typeCustomer === 'COMPANY'
              "
              src="@/assets/img/signature.png"
              class="sign-block"
            />
            <img v-else src="@/assets/img/signature.png" class="sign-block" />
            <br />
            <br />
            <strong v-if="customerName">{{ customerName }}</strong>
            <strong v-else>{{ customerInfo.customerName }}</strong>
          </td>
        </tr>
        <tr v-if="!isAppendix">
          <td colspan="2" align="center" style="border: 0 !important">
            <p style="text-align: center !important">
              <b>CHUYÊN VIÊN KINH DOANH BÊN A</b><br />
              <b>THỰC HIỆN HỢP ĐỒNG</b><br />
              <i>(Ký ghi rõ họ tên)</i><br />
            </p>
            <div style="height: 100px"></div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['dataContract', 'dataAppendix', 'isAppendix', 'sign', 'customerName'],
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataSign() {
        if (this.dataAppendix?.isCreatedWithContract) {
          return this.dataContract.signatureOfMerchantByContract?.[0] ?? null
        } else {
          return this.isAppendix
            ? this.dataAppendix?.signatureOfMerchantByAppendix?.[0]
            : (this.dataContract.signatureOfMerchantByContract?.[0] ?? null)
        }
      },
    },
  }
</script>

<style scoped>
  .sign-block {
    width: 150px;
    height: 150px;
    display: inline-block;
  }
</style>
